
    import {
        computed,
        defineComponent,
        unref,
        type PropType,
    } from 'vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import CheckBoxInputList from '@ve/components/inputs/CheckBoxInputList.vue';
    import { ExWindow } from '@fr/vue/types';
    import { Typo } from '@travelata-libs/ui-kit';
    import { type IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';
    import FilterAttributeMethodsPrepayments from '../lib/FilterAttributeMethodsPrepayments';
    declare let window: ExWindow;
    export default defineComponent({
        name: 'PrepaymentsFilter',
        components: {
            Typo,
            CheckBoxInput,
            CheckBoxInputList,
        },
        props: {
            prepaymentsList: {
                type: Array as PropType<IFirstPaymentDefinition[]>,
                default: () => [],
            },
            selected: {
                type: Array as PropType<number[]>,
                default: () => [],
            },
        },
        emits: ['change'],
        setup(props, { emit }) {
            const isMobile = !!window?.appConfig?.isMobileDomain;

            const filterAttributeMethods = computed(
                () => new FilterAttributeMethodsPrepayments(props.prepaymentsList),
            );

            const listRender = computed(() => unref(filterAttributeMethods).getListFilterAttributes());

            const isAnySelected = computed(() => props.selected.length === 0);

            const selectAny = () => {
                emit('change', []);
            };

            const onSelectionChange = (newSelected: number[]) => {
                emit('change', newSelected);
            };

            return {
                listRender,
                isAnySelected,
                selectAny,
                onSelectionChange,
                isMobile,
            };
        },
    });
